import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, domainsService } from '@v2/services';
import type { CreateDomainPayload } from '@v2/types';

export const useCreateDomain = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: domainsService.createDomain,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.domains.all);
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const createDomain = async (
    payload: CreateDomainPayload
  ): Promise<string | null> => {
    try {
      return await mutation.mutateAsync(payload);
    } catch {
      return null;
    }
  };

  return {
    createDomain,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreateDomain;
